import { render } from "./GamePage.vue?vue&type=template&id=eb2b0bdc&scoped=true&ts=true"
import script from "./GamePage.vue?vue&type=script&lang=ts"
export * from "./GamePage.vue?vue&type=script&lang=ts"

import "./GamePage.vue?vue&type=style&index=0&id=eb2b0bdc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2b0bdc"]])

export default __exports__